/** @format */

const avatarsNamesList = ["GoldenEagle", "Harpia", "StellerEagle"];

export default avatarsNamesList;
